import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"note-section px-5 pb-2 mx-2 my-5",class:[
    _vm.heading ? 'heading' : '',
    _vm.minimized ? 'minimized' : '',
    _vm.accordion ? 'has-accordion' : '',
    _vm.customClass ? _vm.customClass : 'full-width',
    { 'highlight-required-card': _vm.highlightRequired && !_vm.formValidated }
  ],attrs:{"outlined":"","tile":_vm.heading}},[_c(VCardTitle,[_c('label',[(_vm.required && _vm.hasError)?_c('span',{staticClass:"required-asterisk"},[_vm._v("*")]):_vm._e(),_vm._v(" "+_vm._s(_vm.computedLabel)+" ")]),(_vm.accordion)?_c('div',{staticClass:"accordion-section-icon"},[_c(VIcon,{attrs:{"color":"primary"},on:{"click":_vm.minimizeToggle}},[_vm._v(" "+_vm._s(_vm.icons.mdiChevronUp)+" ")])],1):_vm._e()]),_c(VRow,{staticClass:"align-start"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }